export default __webpack_public_path__ + "static/media/phone.2b09742b.svg";